/**
 * Textos de las fechas programadas de una encuesta: inicio y cierre (fin).
 *
 * Son informativas: la encuesta NO se abre ni se cierra sola al llegar la fecha. Se sigue
 * manejando con el interruptor Habilitar/Deshabilitar de la pantalla de detalle. Por eso,
 * cuando la fecha ya pasó, se dice explícitamente en vez de dar a entender que está cerrada.
 */

const leerFecha = (valor) => {
  if (!valor) return null;
  const dia = new Date(valor);
  return Number.isNaN(dia.getTime()) ? null : dia;
};

const textoDia = (dia) =>
  dia.toLocaleDateString('es-CO', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });

/** Solo año, mes y día: las dos fechas vienen de un selector de día, no de una hora. */
const soloDia = (dia) => new Date(dia.getFullYear(), dia.getMonth(), dia.getDate());

export const formatearCierre = (valor, ahora = new Date()) => {
  const dia = leerFecha(valor);
  if (!dia) return null;

  const texto = textoDia(dia);
  return dia < ahora ? `Cierre: ${texto} (ya pasó)` : `Cierra el ${texto}`;
};

/**
 * Texto para mostrar inicio y fin juntos en la lista y en el detalle.
 * Con una sola de las dos fechas, dice solo esa.
 */
export const formatearFechas = (inicio, fin, ahora = new Date()) => {
  const diaInicio = leerFecha(inicio);
  const diaFin = leerFecha(fin);

  if (!diaInicio) return formatearCierre(fin, ahora);
  if (!diaFin) return `Inicia el ${textoDia(diaInicio)}`;

  const rango = `Del ${textoDia(diaInicio)} al ${textoDia(diaFin)}`;
  return diaFin < ahora ? `${rango} (ya pasó)` : rango;
};

/**
 * true si la fecha de fin cae en un día anterior al del inicio. El mismo día es válido.
 * Acepta lo que entiende `new Date`, incluidos los objetos de dayjs del selector.
 */
export const finAntesDeInicio = (inicio, fin) => {
  const diaInicio = leerFecha(inicio);
  const diaFin = leerFecha(fin);
  if (!diaInicio || !diaFin) return false;
  return soloDia(diaFin) < soloDia(diaInicio);
};
